import React from 'react';
import { TableState } from './table-state';
import { noop } from 'lodash';

export const TableStateContext = React.createContext<TableState>({
  columnWidths: {},
  setColumnWidth: noop,
});
